export const validationConfigBuilder = ({ regionCode, wantsNonZA, wantsRemote, wantsZA }) => {
  const template = {
    EU: {
      showField: wantsNonZA || wantsRemote,
      validateField: null,
    },
    ZA: {
      showField: wantsZA || wantsRemote,
      validateField: null,
    },
  }

  template.EU.validateField = wantsNonZA || (wantsRemote && !wantsZA)
  template.ZA.validateField = wantsZA

  if (regionCode === 'za') {
    template.EU.validateField = wantsNonZA
    template.ZA.validateField = wantsZA || (wantsRemote && !wantsNonZA)
  }

  return template
}
